export const SPEC_COMP_LIST = [
    '宁波美美家园服务有限公司',
    '宁波美美家园电器服务有限公司',
    '宁波美美家园电器公司',
    '宁波美美家园电器有限公司',
    '宁波美美家园电器服务公司',
];